import { useContext, useState, useEffect, useRef } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';
import { noSubscriptions } from '../../constants/subscription.constant';

function useSubscription() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestSubscription = (newRequestData) => {
    WebApi.subscriber({
      callName: 'SearchSubscriptions',
      keyFactors: ['SearchSubscriptions'],
      forceRefresh: true,
      payload: { SortDirection: 2 },
    })
      .then((response) => {
        if (isMounted.current) {
          const searchSubscriptions = response.data;
          const subscriptions = searchSubscriptions?.Subscriptions || [];
          if (!subscriptions.length) {
            setUiModel(noSubscriptions);
            return;
          }
          const retrieveSubscriptionRequestAll = subscriptions.reduce(
            (defaultValue, item) => {
              defaultValue.push({
                callName: 'RetrieveSubscription',
                keyFactors: ['RetrieveSubscription'],
                forceRefresh: true,
                payload: { Id: item.Id, IncludeChangeOptions: true },
              });
              return defaultValue;
            },
            [],
          );
          if (retrieveSubscriptionRequestAll.length) {
            WebApi.requestAll([...retrieveSubscriptionRequestAll])
              .then((response) => {
                const retrieveSubscription = response.data;
                const subscriptionResponse = (retrieveSubscriptionNode) =>
                  retrieveSubscriptionNode.reduce((all, item) => {
                    all.push({
                      ...item?.data?.Subscription,
                    });
                    return all;
                  }, []);
                if (isMounted.current) {
                  setUiModel({
                    overview: subscriptions,
                    details: subscriptionResponse(retrieveSubscription),
                  });
                }
              })
              .catch((error) => {
                console.warn({ error });
                if (isMounted.current) {
                  const code = error?.data?.Code;
                  let errorMsg;
                  if (!code) {
                    const unknownFault = generateUnhandledFault(error.data);
                    errorMsg = translateFault(unknownFault).translatedMessage;
                    setFault(errorMsg);
                  } else {
                    errorMsg = translateFault(error.data).translatedMessage;
                    setFault(errorMsg);
                  }
                }
              });
          }
        }
      })
      .catch((error) => {
        console.warn({ error });
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };
  return [uiModel, fault, requestSubscription];
}

export { useSubscription };
export default useSubscription;
